import type { Category } from "@/types/movie";

export const categories: Category[] = [
  {
    id: "latest",
    name: "最新上线",
    description: "第一时间收录新近上线的韩国影视资源，涵盖最新剧情与话题之作。",
    icon: "ri-time-line",
  },
  {
    id: "classic",
    name: "经典佳作",
    description: "历久弥新的经典韩国电影，被反复回味与讨论的口碑之作。",
    icon: "ri-bookmark-3-line",
  },
  {
    id: "highrating",
    name: "高评分电影",
    description: "评分与口碑俱佳的高分作品，剧情、表演与制作更值得细细品读。",
    icon: "ri-star-smile-line",
  },
  {
    id: "eros",
    name: "情欲佳作",
    description: "以情感与欲望为核心的韩国文艺作品，注重人物内心与氛围营造。",
    icon: "ri-heart-3-line",
  },
  {
    id: "drama",
    name: "剧情片",
    description: "细腻刻画人性、家庭与社会的剧情作品，故事扎实、情感真挚。",
    icon: "ri-movie-2-line",
  },
  {
    id: "thriller",
    name: "悬疑惊悚",
    description: "悬念丛生、节奏紧凑的悬疑与惊悚作品，适合喜欢推理与反转的你。",
    icon: "ri-alarm-warning-line",
  },
];